export enum SalesQuotationStatus {
    Draft=0,
    WaitingCustomerAcceptance=1,
    RejectedByCustomer=2,
    Accepted=3,
    Synced=4,
    Cancelled =5,
}